export type CompetitionTypeJsonInput = Record<string, CompetitionTypeEntry>;

export type CompetitionTypeEntry = {
  name: string;
  displayName?: string;
  sport: string;
  competition: string;
  cuiCompetitionTypeId?: string;
  cuiCompetitionId?: string;
  metadata?: Record<string, unknown>;
};

export type CompetitionTypeMap = Record<string, CompetitionTypeEntry>;

/**
 * Parses raw competitionType.json into a lookup map keyed by name.
 * Used by both StyleDictionary (build-time) and client (runtime).
 */
export function parseCompetitionTypeData(input: CompetitionTypeJsonInput): CompetitionTypeMap {
  const map: CompetitionTypeMap = {};
  if (!input || typeof input !== "object") return map;

  for (const [, ct] of Object.entries(input)) {
    if (!ct?.name) continue;
    map[ct.name] = ct;
  }

  return map;
}
